// Have to build the client here, the rule is to prevent us from using clients
// other than the ones defined in this folder
// eslint-disable-next-line no-restricted-imports
import { createStack } from 'hub-http';
import { defaultTo } from 'hub-http/middlewares/core';
import hubapiStack from 'hub-http/stacks/hubapi';
import sseClient from './sseClient';
export const streamingClient = sseClient(createStack(defaultTo('timeout', 1000000), hubapiStack));